import { render, staticRenderFns } from "./AppPrimarias.vue?vue&type=template&id=bc02842a&scoped=true&"
import script from "./AppPrimarias.vue?vue&type=script&lang=js&"
export * from "./AppPrimarias.vue?vue&type=script&lang=js&"
import style0 from "./AppPrimarias.vue?vue&type=style&index=0&id=bc02842a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc02842a",
  null
  
)

export default component.exports